export const RESET_SETTINGS = 'RESET_SETTINGS';
export const LOAD_SETTINGS = 'LOAD_SETTINGS';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const LOAD_USER_BALANCE = 'LOAD_USER_BALANCE';
export const LOAD_EXCHANGE_INFO = 'LOAD_EXCHANGE_INFO';
